import { Amplify, API, graphqlOperation } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api-graphql';

import axios from 'axios';

import { isGraphQLErrorResponse } from '../../../common/utils/typeGuard';
import { responseType } from '../../../common/type/ResponseType';
import { LoginQuery, QueryOutputType } from '../../../common/type/QueryType';
import { LoginInput } from '../../../API';

import awsconfig from '../../../aws-exports';

Amplify.configure(awsconfig);

const query = /* GraphQL */ `
	query Login($input: LoginInput!) {
		login(input: $input) {
			responseType
			message
			loginUserInfo {
				userName
				companyName
				permissionName
				authority
			}
		}
	}
`;

// ログインロックエラーに設定されているメッセージ
const loginLockErrorMessage = 'loginLockError';

// ログインロックエラー時のレスポンス
const loginLockErrorResponse = {
	login: {
		responseType: responseType.loginLockError,
		loginUserInfo: [],
	},
};

/**
 * ログインロックエラーかどうか判定する
 */
const isLoginLockError = (err: unknown) => {
	if (!isGraphQLErrorResponse(err)) {
		return false;
	}

	const errDetail = err.errors[0];
	if (!axios.isAxiosError(errDetail.originalError) || !errDetail.originalError.response) {
		return false;
	}

	if (errDetail.originalError.response.data.errors[0].message !== loginLockErrorMessage) {
		return false;
	}

	return true;
};

/**
 * ログインAPIを呼び出す
 */
export const queryLogin = async (loginInput: LoginInput, authorizationToken: string): Promise<QueryOutputType<LoginQuery>> => {
	try {
		const loginResult = (await API.graphql(graphqlOperation(query, { input: loginInput }, authorizationToken))) as GraphQLResult<LoginQuery>;
		console.log(loginResult.data);

		return [false, loginResult.data];
	} catch (error: unknown) {
		console.error(error);

		if (isLoginLockError(error)) {
			// ログインロックエラーは別途ハンドリングするものとしてエラーなしで返却
			return [false, loginLockErrorResponse];
		}

		return [true, undefined];
	}
};
